import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { FileText } from "lucide-react";
import TermsContent from "./TermsContent";

const DEFAULT_TRIGGER = (
  <button className="hover:text-white inline-flex items-center gap-2 transition-colors">
    <FileText className="w-3.5 h-3.5" />
    Terms of Use / Disclaimer
  </button>
);

export default function TermsModal({ trigger }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <span onClick={() => setOpen(true)} className="cursor-pointer" data-testid="terms-trigger">
        {trigger || DEFAULT_TRIGGER}
      </span>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto p-0 bg-[#fbf9f6] border-stone-200">
          <div className="p-8 md:p-10">
            <DialogHeader>
              <DialogTitle asChild>
                <div>
                  <div className="text-xs uppercase tracking-[0.3em] text-[#b8924a]">Legal Notices</div>
                  <h3 className="font-serif text-4xl text-[#1a2c4e] mt-2 mb-2 leading-tight">Terms of Use &amp; Disclaimer</h3>
                </div>
              </DialogTitle>
            </DialogHeader>
            <div className="h-px w-12 bg-[#b8924a] mb-6" />
            <TermsContent />
            <div className="mt-10 pt-6 border-t border-stone-200 flex justify-end">
              <button
                onClick={() => setOpen(false)}
                className="inline-flex items-center justify-center h-11 px-7 bg-[#1a2c4e] hover:bg-[#11203c] text-white uppercase tracking-[0.2em] text-xs font-medium border border-[#1a2c4e] transition-colors"
                data-testid="terms-close-button"
              >
                Close
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
